import axios from "axios";

const API_ROOT = window.__BACKEND_URL__ + "/api";

const MONITORED_ITEMS_ENDPOINT = API_ROOT + "/monitored_items/";
const MONITORED_ITEMS_ENDPOINT_DETAIL = API_ROOT + "/monitored_items/{0}/";

export const fetchMonitorItems = async () => {
  return await axios.get(MONITORED_ITEMS_ENDPOINT);
};



export const fetchMonitorItem = async (id) => {
  return await axios.get(MONITORED_ITEMS_ENDPOINT_DETAIL.replace("{0}", id));
};

export const updateAlertMethod = async (id, alertMethod) => {
  return await axios.patch(MONITORED_ITEMS_ENDPOINT_DETAIL.replace("{0}", id), {
    alert_method: alertMethod,
  });
};
